import { makeStyles, Theme } from "@material-ui/core/styles";

export const drawerWidth = 280;
export const drawerWithSmallSize = 240;

interface ParticipantProps {
  scrollTop: number;
}

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    "& .MuiPaper-elevation4": {
      boxShadow:
        "0px 5px 16px 0px rgba(0,0,0,0.03), 0px 5px 16px 0px rgba(0,0,0,0.03), 0px 5px 16px 0px rgba(0,0,0,0.03)",
    },
  },
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
    [theme.breakpoints.down("md")]: {
      width: drawerWithSmallSize,
      flexShrink: 0,
    },
  },
  staticAppBar: {
    transform: ({ scrollTop }: ParticipantProps) =>
      `translateY(-${scrollTop}px)`,
    transition: "transform 0.3s ease",
  },
  appBar: {
    backgroundColor: "white",
    paddingLeft: "0px",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: {
    display: "flex",
    flexDirection: "column",
    padding: "0px",
    [theme.breakpoints.up("md")]: {
      marginLeft: `${drawerWidth}px`,
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: `${drawerWithSmallSize}px`,
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
  },
  drawerPaper: {
    backgroundColor: "#FAFBFC",
    [theme.breakpoints.up("md")]: {
      width: drawerWidth,
    },
    [theme.breakpoints.only("md")]: {
      width: drawerWithSmallSize,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      top: "72px",
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    backgroundColor: "#FFFFFF",
    padding: theme.spacing(3),
    marginTop: "128px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "72px",
    },
  },
  mainContainer: {
    backgroundColor: "#FFFFFF",
  },
  marginWithBanner: {
    marginTop: "230px",
    "& .makeStyles-content-9": {
      backgroundColor: "#FFFFFF",
    },
    [theme.breakpoints.up("sm")]: {
      marginTop: "136px",
    },
  },
  logoContainer: {
    padding: "15px 0px 0px 29px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  footerOptions: {
    textDecoration: "none",
    fontWeight: 400,
    color: "#666666",
    "& .menuOptions": {
      "&:hover": {
        color: "#666666",
        cursor: "pointer",
      },
    },
  },
  optionSelected: {
    color: "#4187B6 !important",
  },
  emailLink: {
    fontFamily: "Lato",
    textDecoration: "none",
    color: "#666666",
    fontSize: theme.typography.pxToRem(14),
    padding: "5px",
    fontWeight: 500,
    "&:hover": {
      color: "#4187B6",
      cursor: "pointer",
    },
  },
  childrenContainer: {
    flex: "1 0 auto",
  },
  learningImageContainer: {
    position: "absolute",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
    },
  },
  learningImage: {
    width: "100%",
    [theme.breakpoints.only("xs")]: {
      marginTop: "128px",
      height: "180px",
    },
    [theme.breakpoints.only("sm")]: {
      marginTop: "75px",
      height: "280px",
    },
    [theme.breakpoints.only("md")]: {
      marginTop: "50px",
      maxHeight: "611px",
    },
    [theme.breakpoints.up("md")]: {
      marginTop: "50px",
      maxHeight: "611px",
    },
  },
}));
